import { definePreset } from '../types/portal-settings';

// A towing customer books and tracks their own jobs, and maintains the item
// objects being towed.
export default definePreset({
	pages: ['map', 'items', 'contacts', 'locations', 'reports', 'settings'],
	features: {
		twoFactorAuth: false,
		itemObjects: { enabled: true, allowView: true, allowCreate: true, allowEdit: true },
		jobs: {
			enabled: true,
			fromDateDefault: 'today',
			toDateDefault: 'today',
			allowJobView: true,
			allowJobDetailsView: true,
			allowJobCreate: true,
			allowJobGuidedCreate: true,
			allowJobEdit: true,
		},
		locations: { enabled: true, allowView: true, allowCreate: true, allowEdit: true },
	},
});
